import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '../../../commonComponents';
import { imageSet } from '../../../helper/Images';

const LeftSection = ({
  lenses,
  colorPallete,
  tutorialImage,
  lensCleared,
  lensSelected,
}) => {
  const lensImage = lenses[lensSelected]['icon'];
  return (
    <div className='tutorial-item tutorial-item--left'>
      <div className='image-box'>
        <Image
          className='img-responsive pallete'
          src={imageSet[colorPallete]}
          alt='Color Pallete'
        />
        <Image
          className='img-responsive thumbnail'
          src={imageSet[tutorialImage]}
          alt='Tutorial'
        />
        {!lensCleared && (
          <Image
            className='img-responsive lens'
            src={imageSet[lensImage]}
            alt='Lens'
          />
        )}
      </div>
    </div>
  );
};

LeftSection.PpopTypes = {
  lenses: PropTypes.object,
  colorPallete: PropTypes.number,
  tutorialImage: PropTypes.number,
  lensCleared: PropTypes.bool,
  lensSelected: PropTypes.number,
};

export default LeftSection;
